<template>
  <md-field>
    <md-select v-model="_value">
      <md-option v-for="c in companies" :key="c.code" :value="c.code">{{
        c.name
      }}</md-option>
    </md-select>
  </md-field>
</template>

<script>
export default {
  props: {
    company: {
      type: String,
    },
  },
  computed: {
    /**
     * リスト表示する企業一覧
     */
    companies() {
      return this.$store.state.companies
    },
    _value: {
      get() {
        return this.company
      },
      set(company) {
        this.$emit('update:company', company)
      },
    },
  },
  async created() {
    if (!this.company && this.companies.length > 0) {
      // 復元時にこの値と一致する場合、ツリーの復元ができなかったのでコメント化
      // this.$emit('update:company', this.companies[0].code)
    }
  },
}
</script>
